import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import {
  Navbar, NavbarBrand, Nav,
  NavItem, NavLink, NavbarToggler,
  Collapse
} from 'reactstrap';
import styled from 'styled-components';

import logo from './flexera-branding-logo.png';
import Search from '../../containers/Search/Search';

const Img = styled.img`
  vertical-align: top;
  padding-top: 2px;
`;

class NavigationBar extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: false
    };
  }

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    const searchBar = this.props.location.pathname === "/" ? null : (<Search dark />);
    return (
      <Navbar color="bdna-primary" inverse toggleable="md" role="navigation" aria-labelledby="primary">
        <NavbarBrand tag={Link} to="/" id="header-logo">
          <Img alt="Flexera Technopedia Logo" src={logo} />
        </NavbarBrand>
        <NavbarToggler id="header-toggle" aria-label="Click to toggle button" right onClick={this.toggle}/>
        <Collapse isOpen={this.state.isOpen} navbar>
          <Nav className="d-flex flex-sm-column flex-lg-row flex-grow" navbar>
            <NavItem className="flex-grow px-md-0 px-lg-5">
              {searchBar}
            </NavItem>
            <NavItem>
              <NavLink id="header-browse-link" tag={Link} to="/browse">
                Browse
              </NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    );
  }
}

export default withRouter(NavigationBar);



// WEBPACK FOOTER //
// ./src/components/NavigationBar/NavigationBar.js